import { isPaidCourse } from './priceUtils';

/** Lesson is explicitly or implicitly a video lesson (legacy: has video_url, type not 'text'). */
export function isVideoLesson(lesson) {
  if (!lesson) return false;
  const type = String(lesson.type || '').toLowerCase();
  if (type === 'text') return false;
  if (type === 'video') return true;
  const url = lesson.video_url || lesson.videoUrl;
  return !!url;
}

export function isTextLesson(lesson) {
  if (!lesson) return false;
  const type = String(lesson.type || '').toLowerCase();
  if (type === 'text') return true;
  if (type === 'video') return false;
  // Fallback: if there's rich text content and no video URL, treat as text.
  const url = lesson.video_url || lesson.videoUrl;
  const html = lesson.content || '';
  if (!url && html) return true;
  return !(url);
}

/**
 * Video lessons require payment (or admin-granted enrollment) on paid courses.
 * Text lessons stay accessible without purchase.
 */
export function isVideoLockedForUser(lesson, coursePrice, hasFullAccess) {
  if (!isVideoLesson(lesson)) return false;
  const paid = isPaidCourse(coursePrice);
  if (!paid) return false;
  return !hasFullAccess;
}

export function hasFullCourseAccess(coursePrice, enrolledInCourse) {
  if (!isPaidCourse(coursePrice)) return true;
  return !!enrolledInCourse;
}
